import {Injectable} from '@angular/core';
import type {IDvbError} from '@dv/shared/code';

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in
@Injectable()
export abstract class BackendErrorHandler {

    public abstract handleError(dvbError: IDvbError): void;
}
